import * as actions from "~features/seated-reservation/store/actions/index";
import { SeatSelectTypes, SortTypes } from "~components/reservation/constants";
import { SeatSelectionFilters } from "~graphql/sdk";

export const applySeatFilterDefaults = (
  defaultFilters: SeatSelectionFilters,
  converge: any
): void => {
  if (
    !defaultFilters.seatQuantity &&
    !defaultFilters.selectType &&
    !defaultFilters.sortType
  ) {
    return;
  }

  const options: any = {};

  // Only set properties that are defined in the defaultFilters
  if (defaultFilters.seatQuantity !== undefined) {
    options.amount = defaultFilters.seatQuantity;
  }

  if (defaultFilters.selectType) {
    options.seatSelectType = defaultFilters.selectType as SeatSelectTypes;
  }

  if (defaultFilters.sortType) {
    options.selectedSort = defaultFilters.sortType as SortTypes;
  }

  actions.updateOptions({ options }, converge);
};
